import { Theme } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/styles';
import React, { FC } from 'react';
import { CalendarDay } from './CalendarDay';
import { isLeapYear, useDataValue } from '../utils';

export const activityStyles = {
  hasPlanting: {
    backgroundColor: 'green'
  },
  hasHarvest: {
    backgroundColor: 'yellow'
  },
  hasManureApplication: {
    backgroundColor: 'saddlebrown'
  },
  hasFertilizerApplication: {
    backgroundColor: 'Khaki'
  },
  hasTillage: {
    backgroundColor: 'silver'
  }
};

const useStyles = makeStyles((theme: Theme) => {

  return createStyles({
    timeline: {
      display: 'flex',
      flexDirection: 'column'
    },
    months: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      gap: '2px',
      padding: '0 8px',
      marginBottom: '8px'
    },
    month: {
      display: 'flex',
      flexDirection: 'column'
    },
    monthName: {
      margin: 0
    },
    daysCols: {
      display: 'flex',
      flexDirection: 'row'
    },
    daysCol: {
      display: 'flex',
      flexDirection: 'column'
    },
    ...activityStyles,
    square: {
      width: '10px',
      height: '10px',
      border: '1px solid #333',
      display: 'flex'
    },
    legend: {
      display: 'flex',
      marginLeft: 'auto',
      marginRight: 0,
      border: '1px solid #333',
    },
    legendList: {
      padding: 0,
      display: 'flex',
      gap: '16px',
      margin: '8px'
    },
    legendListItem: {
      display: 'flex',
      gap: '8px',
      fontSize: '11px',
      alignItems: 'center'
    }
  })
});



export const Calendar: FC<any> = function(props) {
  const { definition, path } = props;
  const activities = useDataValue(definition.activities) as undefined | any;
  const year = useDataValue(definition.year) as undefined | any;
  const classes = useStyles({});
  
  const months: Record<string, number> = {
    'Jan': 31,
    'Feb': isLeapYear(year) ? 29 : 28,
    'Mar': 31,
    'Apr': 30,
    'May': 31,
    'Jun': 30,
    'Jul': 31,
    'Aug': 31,
    'Sep': 30,
    'Oct': 31,
    'Nov': 30,
    'Dec': 31
  };
  const daysCol = [...Array(4).keys()];

  

  return (
    <div className = { classes.timeline }>
      <div className = { classes.months }>
        {
          Object.keys(months).map((month, monthIndex) => {
            const daysInMonth = months[month];
            return (
              <div className = { classes.month } key = { 'month-'+monthIndex }>
                <p className = { classes.monthName }>{ month }</p>
                <div className = { classes.daysCols }>
                  {                
                    daysCol.map((dayCol) => {
                      return (
                        <div className = { classes.daysCol } key = { 'dayCol-'+dayCol }>
                          {
                            [...Array(8).keys()].map((day) => {
                              return dayCol*8+day < daysInMonth ? (
                                <CalendarDay
                                  key = { day+'/'+month }
                                  day = { dayCol*8+day+1 }
                                  month = { monthIndex+1 }
                                  year = { year }
                                  activities = { activities }
                                  definition = { definition }
                                  dataPath = { definition.activities }
                                  formPath = { path.concat('/form/contents') }>
                                </CalendarDay>
                              ) : null
                            })
                          }
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            );
          })
        }
        
      </div>
      <legend className = { classes.legend }>
        <ul className = { classes.legendList }>
          <li className = { classes.legendListItem }>
            <span className = { [classes.square, classes.hasPlanting].join(' ') }></span>
            <span>Planting</span>
          </li>
          <li className = { classes.legendListItem }>
            <span className = { [classes.square, classes.hasHarvest].join(' ') }></span>
            <span>Harvest</span>
          </li>
          <li className = { classes.legendListItem }>
            <span className = { [classes.square, classes.hasManureApplication].join(' ') }></span>
            <span>Manure Application</span>
          </li>
          <li className = { classes.legendListItem }>
            <span className = { [classes.square, classes.hasFertilizerApplication].join(' ') }></span>
            <span>Fertilizer Application</span>
          </li>
          <li className = { classes.legendListItem }>
            <span className = { [classes.square, classes.hasTillage].join(' ') }></span>
            <span>Tillage</span>
          </li>
        </ul>
      </legend>
    </div>
  );
}